import { useEffect, useState } from "react";
import { getAdminStatisticsApi } from "api/admin";
import { DonutChart, BarChartH, LineChart30d, ChartCard } from "./admin_charts";
import { C } from "./admin_ui";

export default function AdminStats() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      const r = await getAdminStatisticsApi();
      if (cancelled) return;
      if (r?.success && r.data && !r.data.error) setData(r.data);
      else setError(r?.data?.error || r?.error || "통계 조회 실패");
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <>
        <Title />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
            gap: 14,
          }}
        >
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                border: `1px solid ${C.line}`,
                borderRadius: 14,
                padding: 20,
                height: 220,
              }}
            >
              <div
                style={{
                  width: "30%",
                  height: 14,
                  background: "#F3F4F6",
                  borderRadius: 4,
                  marginBottom: 14,
                }}
              />
              <div
                style={{
                  width: "100%",
                  height: 160,
                  background: "#F9FAFB",
                  borderRadius: 10,
                }}
              />
            </div>
          ))}
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Title />
        <div
          style={{
            padding: "12px 14px",
            borderRadius: 10,
            background: "#FEF2F2",
            border: "1px solid #FECACA",
            color: "#991B1B",
            fontSize: 13,
          }}
        >
          {error}
        </div>
      </>
    );
  }

  const userPie = [
    { label: "농가", value: data?.userByType?.["농가"] || 0, color: "#1D4ED8" },
    { label: "수리기사", value: data?.userByType?.["수리기사"] || 0, color: "#047857" },
  ];
  const otherUserType = Object.entries(data?.userByType || {})
    .filter(([k]) => k !== "농가" && k !== "수리기사")
    .reduce((s, [, v]) => s + (Number(v) || 0), 0);
  if (otherUserType > 0) userPie.push({ label: "기타", value: otherUserType, color: "#9CA3AF" });

  const matchPie = [
    { label: "매칭중", value: data?.matchByStatus?.["0"] || 0, color: "#F59E0B" },
    { label: "매칭완료", value: data?.matchByStatus?.["1"] || 0, color: "#1D4ED8" },
    { label: "완료", value: data?.matchByStatus?.["2"] || 0, color: "#047857" },
  ];

  const servicePie = [
    { label: "답변 대기", value: data?.serviceByStatus?.["0"] || 0, color: "#F59E0B" },
    { label: "답변 완료", value: data?.serviceByStatus?.["1"] || 0, color: "#047857" },
  ];

  const categoryBars = (data?.matchByCategory || []).map((c) => ({
    label: c.name,
    value: c.count,
  }));

  return (
    <>
      <Title />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
          gap: 14,
        }}
      >
        <ChartCard title="회원 유형 분포" hint="활성 회원 기준">
          <DonutChart data={userPie} centerLabel="회원" />
        </ChartCard>
        <ChartCard title="수리 요청 상태" hint="status 기준">
          <DonutChart data={matchPie} centerLabel="요청" />
        </ChartCard>
        <ChartCard title="1:1 문의 응답률" hint="serviceTB status">
          <DonutChart data={servicePie} centerLabel="문의" />
        </ChartCard>
      </div>

      <ChartCard title="카테고리별 수리 요청" hint="상위 10개 (전체 기간)">
        <BarChartH data={categoryBars} />
      </ChartCard>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(440px, 1fr))",
          gap: 14,
        }}
      >
        <ChartCard title="신규 가입 (최근 30일)">
          <LineChart30d data={data?.signupByDay || []} color={C.greenDark} />
        </ChartCard>
        <ChartCard title="수리 요청 (최근 30일)">
          <LineChart30d data={data?.matchByDay || []} color="#1D4ED8" />
        </ChartCard>
      </div>
    </>
  );
}

function Title() {
  return (
    <div>
      <div
        style={{
          fontSize: 24,
          fontWeight: 800,
          color: C.ink,
          letterSpacing: "-0.02em",
        }}
      >
        통계
      </div>
      <div style={{ marginTop: 4, fontSize: 13, color: C.sub }}>
        회원 유형, 수리 요청 추이, 카테고리별 분포를 시각화합니다.
      </div>
    </div>
  );
}
